import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PageHero = ({ title, subtitle, breadcrumb }) => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-sky-50 via-white to-sky-100 border-b border-sky-100">
      <div className="absolute top-0 right-0 w-96 h-96 bg-sky-200/30 rounded-full blur-3xl" />
      <div className="container-app relative py-16 sm:py-20">
        <nav className="flex items-center gap-1.5 text-sm text-slate-500 mb-4">
          <Link to="/" className="hover:text-sky-600">Home</Link>
          <ChevronRight size={15} />
          <span className="text-sky-600 font-medium">{breadcrumb || title}</span>
        </nav>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-slate-900 max-w-3xl leading-tight">
          {title}
        </h1>
        {subtitle && <p className="mt-4 text-lg text-slate-600 max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHero;
